import axios from '@/lib/axios';
import ContactParams from '../types/ContactParams';

const sendContact = (data: ContactParams) => {
  return axios.post('/facility/contact', data);
}

export default sendContact;